import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { type DatadogUserIdentity, toDatadogRumUser } from "./datadog-user";

export function applyDatadogUserIdentity(identity: DatadogUserIdentity | null): void {
  if (!identity) {
    datadogRum.clearUser();
    datadogLogs.clearUser();
    datadogRum.removeGlobalContextProperty("company_id");
    datadogLogs.removeGlobalContextProperty("company_id");
    return;
  }

  const user = toDatadogRumUser(identity);
  datadogRum.setUser(user);
  datadogLogs.setUser(user);

  if (identity.orgId) {
    datadogRum.setGlobalContextProperty("company_id", identity.orgId);
    datadogLogs.setGlobalContextProperty("company_id", identity.orgId);
    return;
  }

  datadogRum.removeGlobalContextProperty("company_id");
  datadogLogs.removeGlobalContextProperty("company_id");
}
